import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {catchError, map} from "rxjs/operators";
import {of, throwError} from "rxjs";
import {CONFIG} from '../../config'

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) {
  }

  getUploadUrl(): any {
    const serviceURL = CONFIG.api.invokeUrl + "/get-upload-url"
    return this.http.get<any>(
      serviceURL,
      {}
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`)
      }));
  }

  getDownloadUrl(objectKey: string): any {
    const serviceURL = CONFIG.api.invokeUrl + "/get-download-url"
    const params = new HttpParams().set('objectKey', objectKey);
    return this.http.get<any>(
      serviceURL,
      {
        params: params
      }
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`)
      }));
  }

  getUploadedFiles(): any {
    const serviceURL = CONFIG.api.invokeUrl + "/get-uploaded-files"
    return this.http.get<any>(
      serviceURL,
      {}
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`)
      }));
  }

  getDownloadableFiles(): any {
    const serviceURL = CONFIG.api.invokeUrl + "/get-downloadable-files"
    return this.http.get<any>(
      serviceURL,
      {}
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`)
      }));
  }

  getAuthorizedExternalUser(): any {
    const serviceURL = CONFIG.api.invokeUrl + "/get-authorized-external-user"
    return this.http.get<any>(
      serviceURL,
      {}
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`)
      }));
  }

  authorizeExternalUser(body: any): any {
    const serviceURL = CONFIG.api.invokeUrl + "/authorize-external-user"
    return this.http.post<any>(
      serviceURL,
      body,
      {}
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`)
      }));
  }

  postFile(body: any): any {
    const serviceURL = CONFIG.api.invokeUrl + "/post-file"
    return this.http.post<any>(
      serviceURL,
      body,
      {}
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`)
      }));
  }

  shareFile(body: any): any {
    const serviceURL = CONFIG.api.invokeUrl + "/share-file"
    return this.http.put<any>(
      serviceURL,
      body,
      {}
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error) => {
        console.log(serviceURL);
        console.log(error);
        return throwError(() => error);
      }));
  }

  removeAccessExternalUser(authorizedEmail: string): any {
    const serviceURL = CONFIG.api.invokeUrl + "/remove-access-external-user"
    const params = new HttpParams().set('authorizedEmail', authorizedEmail);
    return this.http.delete<any>(
      serviceURL,
      {
        params: params
      }).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`)
      }));
  }

  removeSharedAccess(objectKey: string, sharedEmail: string): any {
    const serviceURL = CONFIG.api.invokeUrl + "/remove-shared-access"
    const params = new HttpParams().set('objectKey', objectKey).set('sharedEmail', sharedEmail);
    return this.http.delete<any>(
      serviceURL,
      {
        params: params
      }).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`)
      }));
  }

  deleteFile(objectKey: string): any {
    const serviceURL = CONFIG.api.invokeUrl + "/delete-file"
    const params = new HttpParams().set('objectKey', objectKey);
    return this.http.delete<any>(
      serviceURL,
      {
        params: params
      }).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`)
      }));
  }

  translateFile(body: any): any {
    const serviceURL = CONFIG.api.invokeUrl + "/translate-file";
    return this.http.post<any>(
      serviceURL,
      body,
      {}
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`);
      })
    );
  }

  getTranslationStatus(): any {
    const serviceURL = CONFIG.api.invokeUrl + "/get-translation-status";
    return this.http.get<any>(
      serviceURL,
      {}
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(`serviceURL: ${serviceURL}, error: ${error}, caught ${caught}`);
      })
    );
  }

  initiateMultipartUpload(fileName: string, fileSize: number): any {
    const serviceURL = CONFIG.api.invokeUrl + "/initiate-multipart-upload";
    return this.http.post<any>(
      serviceURL,
      { fileName, fileSize },
      {}
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(null);
      })
    );
  }

  completeMultipartUpload(objectKey: string, uploadId: string, parts: any[]): any {
    const serviceURL = CONFIG.api.invokeUrl + "/complete-multipart-upload";
    return this.http.post<any>(
      serviceURL,
      { objectKey, uploadId, parts },
      {}
    ).pipe(
      map((response: any): string => {
        return response;
      }), catchError((error, caught) => {
        console.log(serviceURL);
        console.log(error);
        console.log(caught);
        return of(null);
      })
    );
  }
}
